// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__2I3rR","slick-next":"CustomSlider_slick-next__1Zex9"};